import dispatchEvent3 from "./dispatchEvent3";

const event3 = {
  dispatchEvent3,
};

export default event3;
